<template>
  <div class="content">
    <div
      id="map"
      :style="{ 'cursor' : [ mapInteractionDisabled ? 'default' : '' ] }"
      @mousemove="mousemove"
      @touchmove="mousemove"
    >
      <Sidebar @layerChanged="layerChanged" />
      <IntroCaroussel v-if="firstVisit" />
      <!-- <AutobahnAppNotice v-if="!firstVisit" /> -->

      <!-- Map buttons Wenn Kartenmodus aktiv -->
      <div
        :class="['kartenmode displayflex',device==='XS' ? 'transformx' : '']"
        :style="{left: device === 'XS' ? '50%' : '120px'}"
        v-if="kartenmode && !(device==='XS' && sidebarActive)"
      >
        <!-- Zurück Button-->
        <div
          class="opacity77 colorWhite boxshadow displayflex flexcenter backgroundDarkDarkGrey borderRadius30 cursor-pointer marginright30 padding10 fontsize18"
          @click="stopKartenmode"
          style="width:48px;height:48px;"
        >
          <SVGIcon name="arrow_back_white" size="small" class="cursor-pointer selfAlignCenter" />
        </div>
        <!-- Kartenansicht anlegen -->
        <div
          class="opacity77 boxshadow zapfen fontsize16 backgroundDarkDarkGrey cursor-pointer"
          v-if="kartenmode.mode === 'Kartenansicht_anlegen'"
          @click="saveKartenansicht"
        >
          <SVGIcon name="kartenausschnitt_white" />
          <div class="marginleft15 selfAlignCenter colorWhite">Kartenansicht speichern</div>
        </div>
        <!-- Route anlegen -->
        <div
          class="opacity77 boxshadow zapfen fontsize16 backgroundDarkDarkGrey cursor-pointer"
          v-if="kartenmode.mode === 'route_anlegen'"
          @click="setRouteGeometryInStore_ReturnToNeueRoute"
        >
          <SVGIcon name="route_white" />
          <div class="marginleft15 selfAlignCenter colorWhite">Strecke speichern</div>
        </div>
        <!-- Route bearbeiten -->
        <div
          class="opacity77 boxshadow zapfen fontsize16 backgroundDarkDarkGrey cursor-pointer"
          v-if="kartenmode.mode === 'route_bearbeiten'"
          @click="setRouteGeometry_RouteBearbeiten"
        >
          <SVGIcon name="route_white" />
          <div class="marginleft15 selfAlignCenter colorWhite">Strecke speichern</div>
        </div>
      </div>

      <!-- Map buttons Für Verkehrsmeldungen und Elektrotankstellen aktiv -->
      <div
        :class="['kartenmode transformx displayflex', device==='XS' ? 'flexwrap flexcenter' : '']"
        v-else-if="(activeLayer['Verkehrsmeldungen'] || activeLayer['Verkehrsprognose'] || activeLayer['E-Tankstellen']) && !ExtendedSidebarActive && !(device==='XS' && sidebarActive)"
        style="left:50%"
      >
        <!-- ETankstellen -->
        <div
          v-if="activeLayer['E-Tankstellen']"
          style="height:37px;"
          class="margin0_20 boxshadow zapfen fontsize16 cursor-pointer borderWidth1 borderStyleSolid borderLightGreen backgroundWhite"
          @click="setActiveProfileOption('ETankstellenFilter'); enableMapHandler()"
        >
          <SVGIcon name="e_tankstelle_on" size="little" />
          <div class="marginleft15 selfAlignCenter colorLightGreen">filtern</div>
        </div>
        <!-- Verkehrsmeldungen -->
        <!-- borderDarkGrey  -->
        <div
          v-if="activeLayer['Verkehrsmeldungen'] || activeLayer['Verkehrsprognose']"
          style="height:37px;"
          :class="['margin0_20 boxshadow zapfen fontsize16 cursor-pointer borderWidth1 borderStyleSolid',
          activeLayer['Verkehrsprognose'] ? 'borderYellow backgroundYellow opacity77' : 'backgroundWhite',
          device==='XS' ? 'margintop10' :'']"
          @click="layerChanged(8); enableMapHandler()"
        >
          <SVGIcon name="stau_off" size="little" />
          <div class="marginleft15 selfAlignCenter colorDarkGrey">Trend in 30 Min</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as L from 'leaflet';
import 'leaflet.markercluster';
import * as wms from 'leaflet.wms';
import pointToLineDistance from '@turf/point-to-line-distance';

import Sidebar from './Sidebar.vue';
import IntroCaroussel from './IntroCaroussel.vue';
import AutobahnAppNotice from './AutobahnAppNotice.vue';

import anschlussstellen from './../HelperClasses/LCL_Anschlussstellen';

export default {
  name: `Map`,
  components: {
    Sidebar,
    IntroCaroussel,
    AutobahnAppNotice
  },
  data: function() {
    return {
      popupOptions: { maxWidth: 250 },
      minZ: 7,
      maxZ: 16,
      reloadIntervalInMinutes: 3,
      map: null,
      tileLayer: null,
      labelLayer: null,
      geojsonLayer: {},
      greyMarkerCluster: null,
      redMarkerCluster: null,
      layerInitialised: false,
      interval: null,
      mapInteractionDisabled: null,
      routeObject: null,

      milchGlasLayer: null,

      route: {
        start: {
          coords: null,
          marker: null,
          icon: L.divIcon({
            html: require(`@/../public/img/vue_svg/start.svg`),
            iconSize: [36, 36],
            popupAnchor: [0, -18]
          })
        },
        ziel: {
          bearing: null,
          coords: null,
          marker: null,
          icon: L.divIcon({
            html: require(`@/../public/img/vue_svg/ziel.svg`),
            iconSize: [36, 36],
            popupAnchor: [0, -18]
          })
        },
        layer: []
      },
      markersInBounds: null,
      routenLayer: {}, // Zur Darstellung der Routen bei Klick auf das Kartensymbol unter MeineRouten
      strecke: null // fürs anlegen & bearbeiten von routen
    };
  },
  computed: {
    URL() {
      return this.$store.state.URL;
    },
    firstVisit() {
      return this.$store.state.firstVisit;
    },
    sidebarActive() {
      return this.$store.state.sidebarActive;
    },
    ExtendedSidebarActive() {
      return this.$store.state.ExtendedSidebarActive;
    },
    device() {
      return this.$store.state.device;
    },
    routen() {
      return this.$store.state.routen;
    },
    layers() {
      return this.$store.state.layers;
    },
    kartenmode() {
      return this.$store.state.kartenmode;
    },
    kartenansicht() {
      return this.$store.state.kartenansicht;
    },
    activeLayer() {
      let obj = {};
      for (const layer of this.layers) {
        if (layer.active) obj[layer.name] = layer.active;
      }
      return obj;
    }
  },
  mounted() {
    this.initMap();
    this.initLayers();
    // Erneuert die Karteninhalte alle X Minuten wie in reloadIntervalInMinutes definiert
    this.interval = setInterval(() => {
      this.initLayers();
    }, this.reloadIntervalInMinutes * 60 * 1000);

    // Funktion zum überwachen der jumpTo Funktion
    // Bei Veränderungen im Store => SetView der Karte
    this.$store.watch(
      state => this.$store.state.jumpTo,
      (newValue, oldValue) => {
        this.map.setView(
          new L.LatLng(newValue.coordinates[1], newValue.coordinates[0]),
          13
        );
        this.$store.commit(`setExtendedSidebarActiveFalse`);
        this.checkLoadLayers();
      }
    );
    // Bei klick auf Karte in route anlegen randomisiert Start und Ziel anlegen
    this.$store.watch(
      state => this.$store.state.kartenmode,
      (newValue, oldValue) => {
        if (!newValue) return;
        if (newValue.mode === `route_anlegen`) {
          this.strecke = newValue.strecke;
          // Neue Route anzeigen
          this.removeAllRoutenLayer();
          const obj = {
            start: {
              coords: [this.strecke.start.y_koord, this.strecke.start.x_koord],
              roadnumber: this.strecke.start.roadnumber,
              desc: this.strecke.start.first_name,
              locationcode: this.strecke.start.locationcode
            },
            ziel: {
              coords: [this.strecke.ziel.y_koord, this.strecke.ziel.x_koord],
              roadnumber: this.strecke.ziel.roadnumber,
              desc: this.strecke.ziel.first_name,
              locationcode: this.strecke.ziel.locationcode
            }
          };
          this.routeObject = obj;
          this.setInitialRoute();
        } else if (newValue.mode === `route_bearbeiten`) {
          this.strecke = newValue.strecke;
          this.removeAllRoutenLayer();
          const obj = {
            start: {
              coords: [this.strecke.start.y_koord, this.strecke.start.x_koord],
              roadnumber: this.strecke.start.roadnumber,
              desc: this.strecke.start.first_name,
              locationcode: this.strecke.start.locationcode
            },
            ziel: {
              coords: [this.strecke.ziel.y_koord, this.strecke.ziel.x_koord],
              roadnumber: this.strecke.ziel.roadnumber,
              desc: this.strecke.ziel.first_name,
              locationcode: this.strecke.ziel.locationcode
            }
          };
          this.routeObject = obj;
          this.setInitialRoute();
        }
      }
    );
    // Wenn bei Routen layerVisible ändert => layer überprüfen
    this.$store.watch(
      state => this.$store.state.routeLayer,
      (newRoute, oldRoute) => {
        if (newRoute.toggleAllOff) {
          // Alle angezeigten Routen entfernen
          this.removeAllRoutenLayer();
        }
        if (newRoute.visible) {
          const layerObj = this.createRouteLayersForMap(
            newRoute.coordinates,
            false
          );
          // layer speichern zum entfernen
          this.routenLayer[newRoute.id] = layerObj;

          // layer der Karte hinzufügen
          this.addRouteLayerToMap(layerObj);
        } else {
          // Bereits vorhanden => löschen von Map und Object
          this.removeRoutenLayer(newRoute.id);
        }
      }
    );

    this.$store.watch(
      state => this.$store.state.reloadLayer,
      (newValue, oldValue) => {
        if (!newValue) return;
        this.initLayers();
        this.$store.commit(`setReloadLayer`, false);
      }
    );
  },
  methods: {
    // ############################
    // Initialisierung der Map
    // ############################
    initMap() {
      // Map
      this.map = L.map(`map`, {
        center: [50.111703, 8.681698], // Frankfurt Römer
        zoom: 11,
        minZoom: this.minZ,
        maxZoom: this.maxZ,
        zoomControl: false,
        fadeAnimation: false,
        zoomAnimation: false
      });

      // Tilelayer
      this.tileLayer = L.tileLayer(
        this.URL + `mapcache/tms/1.0.0/bg@a/{z}/{x}/{y}.png`,
        {
          attribution:
            `&copy; Hessen Mobil und &copy; HERE (p) Intergraph/Hexagon`,
          tms: true
        }
      );
      this.tileLayer.addTo(this.map);

      // Label Layer
      this.labelLayer = L.tileLayer(
        this.URL + `mapcache/tms/1.0.0/label@a/{z}/{x}/{y}.png`,
        {
          tms: true
        }
      );
      this.labelLayer.addTo(this.map);

      // Zoomcontrol
      L.control
        .zoom({
          position: `topright`
        })
        .addTo(this.map);

      if (this.kartenansicht) {
        this.map.fitBounds([
          this.kartenansicht.bounds._southWest,
          this.kartenansicht.bounds._northEast
        ]);
      }

      this.milchGlasLayer = L.rectangle(this.map.getBounds(), {
        color: `rgb(100,100,100)`,
        fillOpacity: 0.3,
        stroke: false,
        renderer: L.svg({ padding: 100 }),
        interactive: false
      });

      this.map.on(`dragstart`, e => {
        onDrag();
      });
      this.map.on(`dragend`, function(e) {
        onDrag();
      });
      this.map.on(`drag`, e => {
        onDrag();
      });
      this.map.on(`zoom`, e => {
        onDrag();
      });

      const onDrag = () => {
        this.milchGlasLayer.setBounds(this.map.getBounds());
      };
    },
    // ############################
    // Initialisierung der Layer
    // ############################
    async initLayers() {
      for (const layer of this.layers) {
        // local Objekt Control
        if (!this.geojsonLayer[layer.name]) this.geojsonLayer[layer.name] = {};

        // WMS initialisieren
        if (layer.wms && !this.geojsonLayer[layer.name].wmsLayer) {
          this.geojsonLayer[layer.name].wmsLayer = wms.overlay(
            this.URL + layer.wms.src,
            {
              minZoom: this.minZ,
              maxZoom: this.maxZ,
              layers: layer.wms.layerName,
              format: layer.wms.format,
              transparent: true
            }
          );
        }
        if (
          layer.icons.filter ||
          layer.icons.reload ||
          !this.layerInitialised
        ) {
          const response = await fetch(
            `${layer.icons.src}?${new Date().getTime()}`,
            {
              credentials: `same-origin`
            }
          );
          const data = await response.json();
          // Speichern der Features für die Listenansicht
          this.$store.commit(`setLayerIconsData`, { id: layer.id, data: data });
          // Ausblenden der Alten Iconlayer falls vorhanden
          if (this.geojsonLayer[layer.name].iconLayer) {
            this.map.removeLayer(this.geojsonLayer[layer.name].iconLayer);
          }

          // Icons darstellen in neu erstelltem MarkerCluster
          this.geojsonLayer[layer.name].iconLayer = this.createMarkerCluster(
            layer.icons.markerCluster
          ).addLayer(this.createGeoJSONLayer(data, layer));
        }
      }
      this.layerInitialised = true;
      this.checkLoadLayers();
    },
    createGeoJSONLayer(data, layer) {
      return L.geoJson(data, {
        pointToLayer: (feature, latlng) => {
          const iconData = layer.icons.iconUrl(feature.properties);
          // Unterscheidung von SVG und PNG zur korrekten Darstellung als icon bzw. divIcon
          const icon =
            iconData.type === `svg`
              ? L.divIcon({
                html: iconData.data,
                iconSize: [36, 36],
                popupAnchor: [0, -18]
              })
              : L.icon({
                iconUrl: iconData.data,
                iconSize: [36, 36],
                popupAnchor: [0, -18]
              });

          return L.marker(latlng, {
            icon,
            title: layer.icons.title(feature.properties)
          });
        },
        onEachFeature: (feature, leafletlayer) => {
          leafletlayer.on(`click`, e => {
            if (leafletlayer._popup !== undefined) {
              leafletlayer.unbindPopup();
            }
            leafletlayer.bindPopup(
              layer.icons.popup({
                props: feature.properties,
                streettype: this.getStreetType(
                  feature.properties.street
                    ? feature.properties.street
                    : feature.properties.roadnumber
                )
              }),
              layer.icons.popupOptions ? layer.icons.popupOptions : this.popupOptions
            );
            leafletlayer.openPopup();
          });
        },
        filter: feature => {
          if (layer.id === 7) {
            for (const filterKey of Object.keys(layer.icons.filter)) {
              if (
                layer.icons.filter[filterKey] &&
                feature.properties[filterKey] !== layer.icons.filter[filterKey]
              ) {
                return false;
              }
            }
            return true;
          }
          return true;
        }
      });
    },
    getStreetType(street) {
      if (!street) return;
      const firstLetter = street.split(``)[0];
      const streettype =
        firstLetter === `A`
          ? `highway`
          : firstLetter === `B`
            ? `road`
            : firstLetter === `L`
              ? `land`
              : firstLetter === `K`
                ? `kreis`
                : firstLetter === `E`
                  ? `empty`
                  : ``;
      return streettype;
    },
    checkLoadLayers() {
      this.layers.forEach(layer => {
        if (layer.active) {
          if (this.geojsonLayer[layer.name].wmsLayer) {
            this.map.addLayer(this.geojsonLayer[layer.name].wmsLayer);
          }
          this.map.addLayer(this.geojsonLayer[layer.name].iconLayer);
        } else {
          if (this.geojsonLayer[layer.name].wmsLayer) {
            this.map.removeLayer(this.geojsonLayer[layer.name].wmsLayer);
          }
          this.map.removeLayer(this.geojsonLayer[layer.name].iconLayer);
        }

        if (layer.id === 8) {
          !layer.active
            ? this.milchGlasLayer.removeFrom(this.map)
            : this.milchGlasLayer.addTo(this.map);
        }
      });
    },
    // ############################
    // Initialisierung der MarkerCluster
    // ############################
    createMarkerCluster(markerCluster) {
      const Cluster = L.MarkerClusterGroup.extend({
        options: {
          polygonOptions: {
            fillColor: `#f00`,
            color: `#ccc`,
            weight: 2,
            opacity: 0,
            fillOpacity: 0
          },
          iconCreateFunction: function(cluster) {
            return L.divIcon({
              html: `<img src="img/vue_svg/${markerCluster.name}.svg" />
              <div 
                style="height:20px;width:20px;position:absolute;top:0;right:0;" 
                class="textcenter backgroundWhite fontweight600 borderRadius30 ${markerCluster.colorClass}"
              >
                ${cluster.getChildCount()}
              </div>`,
              iconSize: L.point(45, 45)
            });
          }
        }
      });
      return new Cluster();
    },
    // ############################
    // Togglen der einzelnen Layer
    // ############################
    layerChanged(layerID) {
      if (layerID) this.toggleLayerActive(layerID);
      this.checkLoadLayers();
    },
    toggleLayerActive(layerID) {
      for (const layer of this.layers) {
        if (layer.id === layerID) layer.active = !layer.active;
        // Wenn Prognoselayer aktiviert wird aktuelle Meldungen ausblenden
        if (layerID === 8) {
          if (layer.id === 0) {
            layer.active = !layer.active;
            !layer.active
              ? this.milchGlasLayer.addTo(this.map)
              : this.milchGlasLayer.removeFrom(this.map);
          }
        }
      }
    },

    setAllLayerVisibility(setTo) {
      for (const layer of this.layers) {
        layer.active = setTo;
      }
      this.checkLoadLayers();
    },

    mousemove(e) {
      // Composed Path für Firefox
      const path = myComposedPath(e.target); // e.path || e.composedPath() ||
      if (!path) return;
      path.forEach((element, index) => {
        if (element.id === `map`) {
          if (
            navigator.userAgent.toLowerCase().indexOf(`firefox`) > -1 ||
            getBrowser()
          ) {
            // if ff || ie || edge
            if (isLeafletMarker(path[index - 1])) this.enableMapHandler();
            else if (path[index - 2]) this.disableMapHandler();
            else this.enableMapHandler();
          } else {
            if (isLeafletMarker(path[index - 1])) this.enableMapHandler();
            else if (path[index - 1]) this.disableMapHandler();
            else this.enableMapHandler();
          }
        }
      });

      // Checks Element, ob es ein Leaflet Marker ist => haben eine Position
      function isLeafletMarker(element) {
        if (typeof element !== `object`) return false;
        if (element._leaflet_pos) return true;
        else return false;
      }

      function myComposedPath(el) {
        let path = [];
        while (el) {
          path.push(el);
          if (el.tagName === `HTML`) {
            path.push(document);
            path.push(window);
            return path;
          }
          el = el.parentElement;
        }
      }
      function getBrowser() {
        let rv = -1; // Return value assumes failure.
        if (navigator.appName === `Microsoft Internet Explorer`) {
          const ua = navigator.userAgent;
          const re = new RegExp(`MSIE ([0-9]{1,}[\\.0-9]{0,})`);
          if (re.exec(ua) !== null) rv = parseFloat(RegExp.$1);
        } else if (navigator.appName === `Netscape`) {
          /// in IE 11 the navigator.appVersion says 'trident'
          /// in Edge the navigator.appVersion does not say trident
          if (navigator.appVersion.indexOf(`Trident`) === -1) rv = 12;
          else rv = 11;
        }
        return rv;
      }
    },
    disableMapHandler() {
      this.map.dragging.disable();
      this.map.touchZoom.disable();
      this.map.doubleClickZoom.disable();
      this.map.scrollWheelZoom.disable();
      this.map.boxZoom.disable();
      this.map.keyboard.disable();
      if (this.map.tap) this.map.tap.disable();
      this.mapInteractionDisabled = true;
    },
    enableMapHandler() {
      this.map.dragging.enable();
      this.map.touchZoom.enable();
      this.map.doubleClickZoom.enable();
      this.map.scrollWheelZoom.enable();
      this.map.boxZoom.enable();
      this.map.keyboard.enable();
      if (this.map.tap) this.map.tap.enable();
      this.mapInteractionDisabled = false;
    },

    // ############################
    // Speichern der aktuellen Kartenansicht mit Bounds und Layer
    // ############################
    saveKartenansicht() {
      // Format => {id: active}
      const currentLayer = {};
      this.layers.forEach(layer => {
        currentLayer[layer.id] = layer.active;
      });
      this.$store.dispatch(`saveKartenansicht`, {
        bounds: this.map.getBounds(),
        currentLayer
      });
      this.$store.commit(`setKartenMode`, null);
      this.$store.commit(`setExtendedSidebarActive`);
    },
    // ############################
    // Speichern der Geometrie der angelegten Route
    // ############################
    setRouteGeometryInStore_ReturnToNeueRoute() {
      const anschlussstellenData = this.getLCLAnschlussstellen();

      // Set Geometry and Anschlussstellendaten
      this.strecke.coordinates = JSON.parse(
        JSON.stringify(this.getActiveRouteLayer().getGeometry)
      );
      this.strecke.start = JSON.parse(
        JSON.stringify(anschlussstellenData.start.anschlussstelle)
      );
      this.strecke.ziel = JSON.parse(
        JSON.stringify(anschlussstellenData.ziel.anschlussstelle)
      );

      // setzen der ID
      if (this.routen.length !== 0) {
        this.strecke.id = this.routen[this.routen.length - 1].id + 1;
      } else this.strecke.id = 1;

      // setzen des Routennamens wenn dieser leer ist
      if (this.strecke.titel.trim() === ``) {
        this.strecke.titel = `Route ${this.strecke.id}`;
      }

      this.$store.dispatch(`saveNeueRoute`, this.strecke);

      this.$store.commit(`setActiveProfilOption`, null);
      this.stopKartenmode();
    },
    setRouteGeometry_RouteBearbeiten() {
      const EditRouteObj = this.$store.state.editStrecke;
      EditRouteObj.coordinates = this.getActiveRouteLayer().getGeometry;

      const anschlussstellenData = this.getLCLAnschlussstellen();
      EditRouteObj.start = anschlussstellenData.start.anschlussstelle;
      EditRouteObj.ziel = anschlussstellenData.ziel.anschlussstelle;
      this.$store.dispatch(`setEditRoute`, EditRouteObj);
      this.$store.dispatch(`saveEditRoute`, EditRouteObj);
      this.$store.commit(`setActiveProfilOption`, null);
      this.stopKartenmode();
    },

    stopKartenmode() {
      this.$store.commit(`setKartenMode`, null);
      this.$store.commit(`setExtendedSidebarActive`);
      this.removeRouteLayerFromMap();
      this.strecke = null;
      this.routeObject = null;
      this.removeAllRoutenLayer();
    },

    getActiveRouteLayer() {
      for (const route of this.route.layer) {
        if (route.active) return route;
      }
    },
    getLCLAnschlussstellen() {
      const startCoords = L.latLng(
        this.getStartCoords(this.getActiveRouteLayer().getGeometry)
      );
      const zielCoords = L.latLng(
        this.getZielCoords(this.getActiveRouteLayer().getGeometry)
      );
      let anschlussstellenData = {
        start: null,
        ziel: null
      };

      for (const option of anschlussstellen.data) {
        const coords = L.latLng(Number(option.y_koord), Number(option.x_koord));
        const distanceStart = coords.distanceTo(startCoords);
        const distanceZiel = coords.distanceTo(zielCoords);
        if (!anschlussstellenData.start) {
          anschlussstellenData.start = {
            distance: distanceStart,
            anschlussstelle: option
          };
        } else if (anschlussstellenData.start.distance > distanceStart) {
          anschlussstellenData.start = {
            distance: distanceStart,
            anschlussstelle: option
          };
        }

        if (!anschlussstellenData.ziel) {
          anschlussstellenData.ziel = {
            distance: distanceZiel,
            anschlussstelle: option
          };
        } else if (anschlussstellenData.ziel.distance > distanceZiel) {
          anschlussstellenData.ziel = {
            distance: distanceZiel,
            anschlussstelle: option
          };
        }
      }
      return anschlussstellenData;
    },
    // ############################
    // Entfernen der gesamten Route
    // ############################
    removeRouteLayerFromMap() {
      if (this.route.start.marker) {
        this.map.removeLayer(this.route.start.marker);
      }
      if (this.route.ziel.marker) {
        this.map.removeLayer(this.route.ziel.marker);
      }
      for (const routeLayer of this.route.layer) {
        this.map.removeLayer(routeLayer);
      }
      this.route.layer = [];
    },

    removeRoutenLayer(id) {
      if (!this.routenLayer[id]) return;
      this.map.removeLayer(this.routenLayer[id].layer);
      this.map.removeLayer(this.routenLayer[id].startMarker);
      this.map.removeLayer(this.routenLayer[id].zielMarker);
      delete this.routenLayer[id];
    },
    removeAllRoutenLayer() {
      for (const id of Object.keys(this.routenLayer)) {
        this.removeRoutenLayer(id);
      }
      this.$store.commit(`setAllRoutenLayerVisible`, false);
    },

    addRouteLayerToMap(layerObj) {
      this.map.addLayer(layerObj.layer);
      this.map.addLayer(layerObj.startMarker);
      this.map.addLayer(layerObj.zielMarker);
      this.map.fitBounds(layerObj.layer.getBounds(), {
        padding: [50, 50]
      });
      if (this.device === `XS`) {
        this.$store.commit(`setExtendedSidebarActiveFalse`);
      }
    },

    // ############################
    // Einstellen der Start und Zielpunkte der Route und Abfrage der Route wenn beide gesetzt sind
    // ############################
    setInitialRoute() {
      for (const routePart of Object.keys(this.routeObject)) {
        this.setRoute(this.routeObject[routePart], routePart);
      }
      // Alle Layer ausblenden beim auswählen der Karte
      this.setAllLayerVisibility(false);
      this.requestRoute();
    },
    setRoute(routeObj, typ) {
      // Entfernen des alten Markers von der Karte
      if (this.route[typ].marker) this.map.removeLayer(this.route[typ].marker);
      // Speichern der Koordinaten zur abfrage
      if (routeObj.coords.lat) {
        this.route[typ].coords =
          routeObj.coords.lng + `,` + routeObj.coords.lat;
      } else {
        this.route[typ].coords = routeObj.coords[1] + `,` + routeObj.coords[0];
      }

      this.route[typ].locationcode = routeObj.locationcode;
      // Setzen des Bearings für den Typen

      // Marker definieren und der Karte hinzufügen
      this.route[typ].marker = L.marker(routeObj.coords, {
        icon: this.route[typ].icon,
        zIndexOffset: 1000
      }).addTo(this.map);

      this.route[typ].marker.on(`click`, event => {
        const html = `
        <div class="backgroundDarkBlue colorWhite textcenter widthFit marginbottom15 fontweight600" style="padding:1.5px 10px">
          ${this.routeObject[typ].roadnumber}
        </div>
        <strong>${typ.replace(/^\w/, c => c.toUpperCase())}</strong>
        <div>${this.routeObject[typ].desc}</div>
        `;
        this.route[typ].marker.unbindPopup();
        this.route[typ].marker.bindPopup(html, this.popupOptions).openPopup();
      });
    },
    // ############################
    // Route abfragen
    // ############################
    requestRoute() {
      // Route entfernen falls vorhanden => neue Route speichern und der Karte hinzufügen
      if (this.route.layer) {
        for (const routeLayer of this.route.layer) {
          this.map.removeLayer(routeLayer);
        }
        this.route.layer = [];
      }
      const color = `#64b5f6`;
      const routeLayer = L.geoJSON(this.strecke.coordinates, {
        style: feature => {
          return getStyleObject(color);
        }
      });
      routeLayer.getLatLng = this.strecke.coordinates.coordinates;
      routeLayer.getGeometry = this.strecke.coordinates;
      routeLayer.active = true;
      this.map.addLayer(routeLayer);
      this.route.layer.push(routeLayer);
      // Start/Ziel Marker auf Anfang/Ende matchen (erster und letzter Punkt) => zoom auf Route
      const startCoords = this.getStartCoords(this.strecke.coordinates);
      const zielCoords = this.getZielCoords(this.strecke.coordinates);

      this.route.start.marker.setLatLng(new L.LatLng(startCoords));
      this.route.ziel.marker.setLatLng(new L.LatLng(zielCoords));
      this.map.fitBounds(this.route.layer[0].getBounds(), {
        padding: [50, 50]
      });

      function getStyleObject(color) {
        return { color: color, weight: 5 };
      }
    },

    getStartCoords(featureCollection) {
      const feature = featureCollection.features[0];
      const coords = feature.geometry.coordinates[0];
      return [coords[1], coords[0]];
    },
    getZielCoords(featureCollection) {
      const feature =
        featureCollection.features[featureCollection.features.length - 1];
      const coords =
        feature.geometry.coordinates[feature.geometry.coordinates.length - 1];
      return [coords[1], coords[0]];
    },
    checkMarkerOnRoute(featureCollection, layername) {
      const routeBounds = L.geoJSON(featureCollection).getBounds();
      const markersInBounds = [];
      // get all Markers in Bounds
      const clusterlayer = this.geojsonLayer[layername].iconLayer;
      clusterlayer.eachLayer(layer => {
        if (routeBounds.contains(layer.getLatLng())) {
          markersInBounds.push(layer);
        }
      });

      // check all Marker along Route if inside Puffer (X Meter)
      const markerAlongRoute = {};
      if (layername === `Verkehrsmeldungen`) {
        // Überprüfung der Verkehrsmeldungen mithilfe der LCL Listen
        const lclliste = featureCollection.features[0].properties.lclliste;
        for (const markerinBound of markersInBounds) {
          // Überprüfung aller Marker die in der BBox sind
          const markerLCLListe = markerinBound.feature.properties.lcliste;
          // Wenn der marker keine LCLListe hat nächsten Marker prüfen => Fehler abfangen
          if (markerLCLListe.length === 0) continue;
          for (let i = 0; i < lclliste.length; i++) {
            // lclliste => Geometrie der Route => erstes Feature.properties beinhaltet die liste
            const markerLCLIndex = markerLCLListe.indexOf(Number(lclliste[i]));
            const nextmarkerLCL = markerLCLListe.indexOf(
              Number(lclliste[i + 1])
            );
            // Überprüfung ob der aktuelle lcl in der Liste der Meldung vorhanden ist und ob der nächste darauf folgt => für die Richtung
            if (markerLCLIndex !== -1 && nextmarkerLCL === markerLCLIndex + 1) {
              markerAlongRoute[markerinBound._leaflet_id] = markerinBound;
              break;
            }
          }
        }
      } else {
        for (const feature of featureCollection.features) {
          for (const markerinBound of markersInBounds) {
            const distance = pointToLineDistance(
              markerinBound.feature,
              feature,
              {
                units: `meters`
              }
            );
            if (distance < 150) {
              markerAlongRoute[markerinBound._leaflet_id] = markerinBound;
            }
          }
        }
      }
      return markerAlongRoute;
    },
    createRouteLayersForMap(coordinates, editMode) {
      const layer = L.geoJSON(coordinates);
      const startMarker = L.marker(this.getStartCoords(coordinates), {
        icon: this.route.start.icon,
        draggable: editMode,
        zIndexOffset: 1000
      });
      const zielMarker = L.marker(this.getZielCoords(coordinates), {
        icon: this.route.ziel.icon,
        draggable: editMode,
        zIndexOffset: 1000
      });

      return {
        // Layer erstellen
        layer,
        startMarker,
        zielMarker
      };
    },
    setActiveProfileOption(setTo) {
      this.$store.commit(`setExtendedSidebar`, setTo);
      this.$store.commit(`setExtendedSidebarActive`);
    }
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("../../node_modules/leaflet/dist/leaflet.css");
@import url("../../node_modules/leaflet.markercluster/dist/MarkerCluster.css");

.content {
  height: calc(100% - 50px);
  width: 100%;
}
@media (min-width: 769px) {
  .content {
    height: calc(100% - 110px - 50px);
  }
}

#map {
  width: 100%;
  height: 100%;
  font-family: "Droid Sans", sans-serif;
  color: #363d3f;
}

.kartenmode {
  position: absolute;
  top: 10px;
  z-index: 1001;
}
.kartenmode.transformx {
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.zapfen {
  width: fit-content;
  border-radius: 30px;
  padding: 5px 10px;
  color: white;
  display: flex;

  white-space: nowrap;
}

.blurBackground {
  background-color: hotpink;
}

/* outer box / circle  */
.cluster_grey {
  background-color: rgba(82, 92, 97, 0.3);
  background-clip: padding-box;
  border-radius: 20px;
}

/* inner box / circle */
.cluster_grey div {
  background-color: rgba(82, 92, 97, 0.4);
  width: 30px;
  height: 30px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  border-radius: 15px;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
}

.cluster_grey span {
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
}

.cluster_red {
  background-color: rgba(220, 45, 51, 0.3);
  background-clip: padding-box;
  border-radius: 20px;
}

/* inner box / circle */
.cluster_red div {
  background-color: rgba(220, 45, 51, 0.4);
  width: 30px;
  height: 30px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  border-radius: 15px;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
}

.cluster_red span {
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
}

.boxshadow {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 16%);
}

.highway {
  background: #1a70b8;
  border: 1px solid #1a70b8;
  color: #ffffff;
}

.road {
  background: #fecb00;
  color: #525c61;
  border: 1px solid #525c61;
}

.kreis {
  background: #fff;
  color: #333 !important;
  border: 1px solid #000;
  font-weight: normal !important;
}

.land {
  background: #fff;
  color: #333 !important;
  border: 1px solid #000;
}

.opacity77 {
  opacity: 0.77;
}
</style>
